import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import styles from './index.module.scss.js';

const ProviderCard = ({
  to,
  icon,
  games,
  version = "v1",
  whiteImageFilter,
  className,
  label = "Games",
  ...props
}) => {
  const [isMouseenter, setMouseenter] = useState(false);
  console.log("isMouseenter", isMouseenter);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.container),
      onMouseEnter: () => {
        setMouseenter(true);
      },
      onMouseLeave: () => setMouseenter(false)
    },
    /* @__PURE__ */ React.createElement(
      Link,
      {
        className: cx(styles.box, className, {
          [styles[version]]: !!version,
          [styles["white-filter"]]: whiteImageFilter,
          [styles.hover]: isMouseenter
        }),
        to,
        ...props
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.wrapper }, /* @__PURE__ */ React.createElement("div", { className: styles.wrapper__inner }, /* @__PURE__ */ React.createElement("div", { className: styles.icon }, /* @__PURE__ */ React.createElement("img", { src: icon, alt: icon })), version === "v1" && /* @__PURE__ */ React.createElement("div", { className: styles.divider }), /* @__PURE__ */ React.createElement("div", { className: styles.info }, games, " ", label)))
    )
  );
};
ProviderCard.displayName = "ProviderCard";

export { ProviderCard };
//# sourceMappingURL=index.js.map
